<script lang="ts">
import { Component } from "vue-property-decorator";
import ProfileAva from "@/components/ui/ProfileAva.vue";
import userModule from "@/store/user.module";
@Component({
  name: "CabinetProfileAva",
})
export default class extends ProfileAva {
  async created() {
    this.getAva();
  }
  async getAva() {
    const src: Blob = await userModule.getUserImage();
    const hasAva = src && src.size !== 0;
    userModule.setHasAva(hasAva);
    if (hasAva) {
      this.imageSrc = URL.createObjectURL(src);
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
* {
  @include ava(73px);
  font-size: 45px;
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  * {
    @include avaSmall(53px);
    font-size: 25px;
  }
}
</style>
